<script setup lang="ts">
export interface IconTicket {
  fill?: string;
  width?: number;
  height?: number;
}
const props = withDefaults(defineProps<IconTicket>(), { fill: "#A9B7D1", width: 24, height: 24 });
</script>

<template>
  <svg :width="props.width" :height="props.height" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <!-- eslint-disable-next-line max-len -->
    <path d="m17.583 13.97 1.137-.52.733 1.535L24 12.905l-1.541-3.221c-1.137.52-2.501.05-3.032-1.09-.53-1.115-.025-2.453 1.112-2.973L18.998 2.4l-4.573 2.081.733 1.536-1.137.52-.733-1.536L0 11.096l1.541 3.22c1.137-.52 2.501-.05 3.032 1.09A2.208 2.208 0 0 1 3.46 18.38L5.002 21.6l13.314-6.094-.733-1.536zm-11.95-2.7 6.291-2.875.53 1.115-6.29 2.874-.53-1.115zm1.138 2.427 6.29-2.874.53 1.115-6.29 2.874-.53-1.115zm1.692 3.543-.53-1.115 6.29-2.874.53 1.115-6.29 2.874zm6.165-9.489 1.136-.52.885 1.858-1.137.52-.884-1.858zm1.465 3.122 1.137-.52.884 1.858-1.112.52-.91-1.858z" :fill="props.fill" fill-rule="evenodd" />
  </svg>
</template>
